import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import NamedDto from 'modules/base/dto/NamedDto';
import { format } from 'date-fns';

class ModelValidationLogTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'modelValidationLogTableControl';
	}

	/**
	* @param {string} session
	* @param {number} firstResult
	* @param {number} maxResults
	* @return {Promise<GenericTableDto<NamedDto>>}
	*/
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, NamedDto)))
				.catch(reject);
		});
	}

	/**
	* @param {string} name
	* @return {Promise<any>}
	*/
	getRuns(name) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getRuns`, {
					name
				})
				.then(response => {
					let optionList = [];
					if (response.data) for (let i = 0; i < response.data.length; i += 1) optionList.push({ id: response.data[i].id, name: format(new Date(response.data[i].ts), 'yyyy.MM.dd. HH:mm:ss') + ' - ' + response.data[i].optimizer_name });
					resolve(optionList)
				})
				.catch(reject);
		});
	}

	/**
	* @param {string} name
	* @param {number} runId
	* @return {Promise<any>}
	*/
	getTrajectory(name, runId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getTrajectory`, {
					name,
					runId
				})
				.then(response => { resolve(response) })
				.catch(reject);
		});
	}

	/**
	* @param {number} id
	* @param {Date} ts
	* @return {Promise<any>}
	*/
	getDataByTs(id, ts) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getDataByTs`, {
					id,
					ts
				})
				.then(response => {
					try {
						if (typeof response === "string") {
							const safe = response.replace(/\bNaN\b/g, "null").replace(/\bInfinity\b/g, "null").replace(/\b-Infinity\b/g, "null");
							resolve(JSON.parse(safe));
						}
						else if (typeof response?.data === "string") {
							const safe = response.data.replace(/\bNaN\b/g, "null").replace(/\bInfinity\b/g, "null").replace(/\b-Infinity\b/g, "null");
							resolve(JSON.parse(safe));
						}
						else { resolve(response?.data ?? response); }
					} catch (err) {
						reject(err);
					}
				})
				.catch(reject);
		});
	}

	/**
	* @param {number} id 
	* @param {Date} dateFrom
	* @param {Date} dateTo
	* @return {Promise<any>}
	*/
	getTimestampsInDateInterval(id, dateFrom, dateTo) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getTimestampsInDateInterval`, {
					id,
					dateFrom,
					dateTo
				})
				.then(response => { resolve(response) })
				.catch(reject);
		});
	}

	/**
	* @param {number} id 
	* @param {Date} dateFrom
	* @param {Date} dateTo
	* @return {Promise<any>}
	*/
	getData(id, dateFrom, dateTo) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id,
					dateFrom,
					dateTo
				})
				.then(response => {
					try {
						if (typeof response === "string") {
							const safe = response.replace(/\bNaN\b/g, "null").replace(/\bInfinity\b/g, "null").replace(/\b-Infinity\b/g, "null");
							resolve(JSON.parse(safe));
						}
						else if (typeof response?.data === "string") {
							const safe = response.data.replace(/\bNaN\b/g, "null").replace(/\bInfinity\b/g, "null").replace(/\b-Infinity\b/g, "null");
							resolve(JSON.parse(safe));
						}
						else { resolve(response?.data ?? response); }
					} catch (err) {
						reject(err);
					}
				})
				.catch(reject);
		});
	}
}

export default new ModelValidationLogTableService();